import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Alignment,
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";

interface Props {
  name: string;
  value: Alignment;
  strict?: boolean;
  onChange: (changed: Alignment) => void;
}

// export interface Alignment {
//   order: "Lawful","Neutral","Chaotic","Non-Lawful","Non-Neutral","Non-Chaotic","Any","Unaligned";
//   moral: "Good","Neutral","Evil","Non-Good","Non-Neutral","Non-Evil","Any","Unaligned";
// }

export default function SelectAlignmentBox({
  name,
  value,
  strict = false,
  onChange
}: Props) {
  const [my_value, setValue] = useState(value);

  const orders = strict ? ["Lawful","Neutral","Chaotic"] : ["Lawful","Neutral","Chaotic","Non-Lawful","Non-Neutral","Non-Chaotic","Any","Unaligned"];
  const morals = strict ? ["Good","Neutral","Evil"] : ["Good","Neutral","Evil","Non-Good","Non-Neutral","Non-Evil","Any","Unaligned"];
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 4
        }}>{ name }</Grid>
      <Grid
        size={{
          xs: 4
        }}>
        <SelectStringBox
          name="Order Spectrum"
          value={my_value.order}
          options={orders}
          onChange={(changed: string) => {
            const new_value = my_value;
            (new_value.order as string) = changed;
            onChange(new_value);
            setValue(new_value);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 4
        }}>
        <SelectStringBox
          name="Moral Spectrum"
          value={my_value.moral}
          options={morals}
          onChange={(changed: string) => {
            const new_value = my_value;
            (new_value.moral as string) = changed;
            onChange(new_value);
            setValue(new_value);
          }}
        />
      </Grid>
    </Grid>
  );
}
